import { useState, useContext, useEffect } from 'react'
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from '@material-ui/core'
import { useForm, Controller } from 'react-hook-form'
import ButtonSp from '../ui/ButtonSp'
import CalWeightModal from './CalWeightModal'
import useStyles from './formStyles'
import { Context } from '../../context'
import AddressAutoComplete from '../ui/AddressAutoComplete'
import Axios from 'axios'
import {
  getWlhByBoxSize,
  boxSizesKeysAndLabels,
} from '../utility/boxSizeUtility'
import NumberFormat from 'react-number-format'
import {
  addressObjectToLabel,
  postcodeToFirstFoundAddress,
} from '../utility/addressObjectUtility'

import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const DomesticForm = ({
  submitMode,
  setCheckpriceResultList,
  setResultStatus,
  setLastFetchBody,
  displayMode = 'full', // 'full' for full form, 'bar' for bar style of form
  isActive = false,
  required = true,
}) => {
  const [isCalModalOpen, setCalModalOpen] = useState(false)
  // v for the future version
  // const [isMulDestModalOpen, setMulDestModalOpen] = useState(false)

  const { handleSubmit, control, setValue, errors, trigger } = useForm({
    shouldFocusError: false,
  })
  const { state, dispatch, onRouting } = useContext(Context)

  const { t } = useTranslation('checkprice')
  const Router = useRouter()
  const language = Router.locale

  const classes = useStyles()

  const boxSizesKeysAndLabelsWithUndefined = [
    ...boxSizesKeysAndLabels,
    ['undefined', t('undefined')],
  ]

  // handlers of normal form
  const handleFormSubmit = handleSubmit((data) => {
    const parsedWeight = parseInt(data.weight.replace(/\,/g, ''), 10)

    let neoQuery = ``

    // * start about from *//
    if (data?.origin?.value?.zipcode) {
      neoQuery = `${neoQuery}postcode_from=${data?.origin?.value?.zipcode}&`
    }

    if (data?.origin?.value?.dist) {
      neoQuery = `${neoQuery}dist_from=${data?.origin?.value?.dist}&`
    }

    if (data?.origin?.value?.prov) {
      neoQuery = `${neoQuery}prov_from=${data?.origin?.value?.prov}&`
    }

    if (data?.origin?.value?.subdist) {
      neoQuery = `${neoQuery}subdist_from=${data?.origin?.value?.subdist}&`
    }

    if (data?.origin?.value?.zone) {
      neoQuery = `${neoQuery}zone_from=${data?.origin?.value?.zone}&`
    }
    // // * end about from *//

    // // * start about to *//
    if (data?.destination?.value?.zipcode) {
      neoQuery = `${neoQuery}postcode_to=${data?.destination?.value?.zipcode}&`
    }
    if (data?.destination?.value?.dist) {
      neoQuery = `${neoQuery}dist_to=${data?.destination?.value?.dist}&`
    }

    if (data?.destination?.value?.prov) {
      neoQuery = `${neoQuery}prov_to=${data?.destination?.value?.prov}&`
    }

    if (data?.destination?.value?.subdist) {
      neoQuery = `${neoQuery}subdist_to=${data?.destination?.value?.subdist}&`
    }

    if (data?.destination?.value?.zone) {
      neoQuery = `${neoQuery}zone_to=${data?.destination?.value?.zone}&`
    }
    // * end about to *//
    // * start weigth *//
    if (parsedWeight) {
      neoQuery = `${neoQuery}weight=${parsedWeight}&`
    }
    // * end weigth  *//
    // * start size *//
    if (data?.boxSize) {
      neoQuery = `${neoQuery}size_parcel=${data?.boxSize}`
    }

    // const query = `postcode_from=${data?.origin?.value?.zipcode}&dist_from=${data?.origin?.value?.dist}&prov_from=${data?.origin?.value?.prov}&subdist_from=${data?.origin?.value?.subdist}&zone_from=${data?.origin?.value?.zone}&postcode_to=${data?.destination?.value?.zipcode}&dist_to=${data?.destination?.value?.dist}&prov_to=${data?.destination?.value?.prov}&subdist_to=${data?.destination?.value?.subdist}&zone_to=${data?.destination?.value?.zone}&weight=${parsedWeight}&size_parcel=${data?.boxSize}`
    // // `

    if (data?.serviceType) {
      neoQuery = `${neoQuery}service_type=${data?.serviceType}`
    }

    const query = neoQuery

    if (submitMode === 'redirect') {
      onRouting('/checkprice', query)
    } else if (submitMode === 'fetch') {
      setResultStatus('loading')

      onRouting('/checkprice', query, { shallow: true })
      const originObject = {
        name: '-',
        address: '-',
        district: data.origin?.value?.subdist,
        state: data.origin?.value?.dist,
        province: data.origin?.value?.prov,
        postcode: data.origin?.value?.zipcode,
        tel: '-',
      }
      const destinationObject = {
        name: '-',
        address: '-',
        district: data.destination?.value?.subdist,
        state: data.destination?.value?.dist,
        province: data.destination?.value?.prov,
        postcode: data.destination?.value?.zipcode,
        tel: '-',
      }
      const { width, length, height } = getWlhByBoxSize(
        data.boxSize && data.boxSize !== 'undefined' ? data.boxSize : '222'
      )
      const parcelObject = {
        name: '-',
        weight: parsedWeight > 100 ? parsedWeight : 100,
        width,
        length,
        height,
      }
      const fetchBody = {
        data: [
          {
            from: originObject,
            to: destinationObject,
            parcel: parcelObject,
            showall: 1,
          },
        ],
        lang: language,
      }
      if (setLastFetchBody) setLastFetchBody(fetchBody)
      Axios.post('/api/checkprice/fetch', fetchBody)
        .then((res) => {
          setResultStatus('success')
          setCheckpriceResultList(res.data)
        })
        .catch((err) => setResultStatus('error'))
    }
  })

  const handleFormContext = () => {
    const query = Router.query
    if (!query) return
    const originAddressObject = {
      zipcode: query.postcode_from,
      dist: query.dist_from,
      prov: query.prov_from,
      subdist: query.subdist_from,
      zone: query.zone_from,
    }
    const originFieldObject = {
      label: addressObjectToLabel(originAddressObject),
      value: originAddressObject,
    }
    setValue('origin', originFieldObject)
    const destAddressObject = {
      zipcode: query.postcode_to,
      dist: query.dist_to,
      prov: query.prov_to,
      subdist: query.subdist_to,
      zone: query.zone_to,
    }
    const destFieldObject = {
      label: addressObjectToLabel(destAddressObject),
      value: destAddressObject,
    }
    setValue('destination', destFieldObject)
    setValue('weight', query.weight ? String(query.weight) : '200')
    setValue('boxSize', query.size_parcel ? query.size_parcel : 'ก')
    setValue('serviceType', query.service_type ? query.service_type : 'MOTORCYCLE')
    handleFormSubmit()
  }

  const handleFormContextOld = async () => {
    const query = Router.query
    if (!query) return
    const originAddressObject = await postcodeToFirstFoundAddress(
      query.postcode_from
    )
    const originFieldObject = {
      label: addressObjectToLabel(originAddressObject),
      value: originAddressObject,
    }
    const destAddressObject = await postcodeToFirstFoundAddress(
      query.postcode_to
    )
    const destFieldObject = {
      label: addressObjectToLabel(destAddressObject),
      value: destAddressObject,
    }
    setValue('origin', originFieldObject)
    setValue('destination', destFieldObject)
    setValue('weight', query.weight ? String(query.weight) : '200')
    setValue('boxSize', query.size_parcel ? query.size_parcel : 'ก')
    setValue('serviceType', query.service_type ? query.service_type : 'MOTORCYCLE')
    handleFormSubmit()
  }

  const showExample = (query) => {
    const origin = {
      label: 'แขวงพญาไท, เขตพญาไท, กรุงเทพมหานคร, 10400',
      value: {
        zipcode: 10400,
        subdist: 'พญาไท',
        dist: 'พญาไท',
        prov: 'กรุงเทพมหานคร',
        zone: 'bkk',
      },
    }

    if (haveValidFormQueries(query)) {
      const originAddressObject = {
        zipcode: query.postcode_from,
        dist: query.dist_from,
        prov: query.prov_from,
        subdist: query.subdist_from,
        zone: query.zone_from,
      }
      origin.label = addressObjectToLabel(originAddressObject)
      origin.value = originAddressObject
    }
    setValue('origin', {
      ...origin,
    })

    const destination = {
      label: 'แขวงปทุมวัน, เขตปทุมวัน, กรุงเทพมหานคร, 10330',
      value: {
        zipcode: 10330,
        subdist: 'ปทุมวัน',
        dist: 'ปทุมวัน',
        prov: 'กรุงเทพมหานคร',
        zone: 'bkk',
      },
    }

    if (haveValidToQueries(query)) {
      const destAddressObject = {
        zipcode: query.postcode_to,
        dist: query.dist_to,
        prov: query.prov_to,
        subdist: query.subdist_to,
        zone: query.zone_to,
      }
      destination.label = addressObjectToLabel(destAddressObject)
      destination.value = destAddressObject
    }

    setValue('destination', { ...destination })
    setValue('weight', query.weight ? String(query.weight) : '200')
    setValue('boxSize', query.size_parcel ? query.size_parcel : 'ก')
    setValue('serviceType', query.service_type ? query.service_type : 'MOTORCYCLE')
    handleFormSubmit()
  }

  // v for the future version
  // handler of multiple destination modal form
  // not used for now -------------------------
  // const handleMultiDestSubmit = (data) => {
  //   setMulDestModalOpen(false)
  //   if (submitMode === 'redirect') {
  //     dispatch({ type: 'SET_CHECKPRICE_MODE_MULTIDEST_DOMESTIC' })
  //     dispatch({ type: 'SET_CHECKPRICE_FORM', payload: data })
  //     Router.push('/checkprice')
  //   } else if (submitMode === 'fetch') {
  //     alert(JSON.stringify(data))
  //   }
  // }

  // const handleFormContextMultiDest = () => {
  //   handleMultiDestSubmit(state.checkpriceForm)
  //   dispatch({ type: 'CLEAR_CHECKPRICE_FORM' })
  //   dispatch({ type: 'CLEAR_CHECKPRICE_MODE' })
  // }

  const haveValidQueries = () => {
    const query = Router.query
    if (!query) return false
    // Only the keys that IDENTIFY the address are required. zone_from/zone_to
    // are NOT (the address autocomplete result often omits `zone`, and neither
    // the price fetch nor the field label uses it), and weight/size_parcel are
    // optional (defaulted below). Requiring them here made a fully-entered
    // address from the homepage fall through to showExample() — silently
    // replacing it with the 10400→10330 Bangkok example on /checkprice.
    const requiredKeys = [
      'postcode_from',
      'dist_from',
      'prov_from',
      'subdist_from',
      'postcode_to',
      'dist_to',
      'prov_to',
      'subdist_to',
    ]
    const isQueryValid = requiredKeys.every((key) => key in query)
    return isQueryValid
  }

  const haveValidOldQueries = () => {
    const query = Router.query
    if (!query) return false
    const requiredKeys = [
      'postcode_from',
      'postcode_to',
      'weight',
      'size_parcel',
    ]
    const isQueryValid = requiredKeys.every((key) => key in query)
    return isQueryValid
  }

  const haveValidFormQueries = (query) => {
    if (!query) return false
    const requiredKeys = [
      'postcode_from',
      'dist_from',
      'prov_from',
      'subdist_from',
      'zone_from',
    ]
    const isQueryValid = requiredKeys.every((key) => key in query)
    return isQueryValid
  }

  const haveValidToQueries = (query) => {
    if (!query) return false
    const requiredKeys = [
      'postcode_to',
      'dist_to',
      'prov_to',
      'subdist_to',
      'zone_to',
    ]
    const isQueryValid = requiredKeys.every((key) => key in query)
    return isQueryValid
  }

  useEffect(() => {
    if (!Router.isReady) return
    if (Router.query?.typeid === 'inter') return
    if (submitMode === 'fetch' && haveValidQueries(Router.query)) {
      handleFormContext()
    } else if (submitMode === 'fetch' && haveValidOldQueries(Router.query)) {
      handleFormContextOld()
    } else if (submitMode === 'fetch') {
      showExample(Router.query)
    }
    // v for the future version
    // } else if (
    //   submitMode === 'fetch' &&
    //   state.checkpriceMode === 'multidest-domestic'
    // ) {
    //   handleFormContextMultiDest()
    // }
  }, [Router.isReady])

  useEffect(() => {
    const hasError = !!Object.keys(errors)[0]

    if (hasError && Router.pathname === '/') {
      onRouting('/checkprice')
    }
  }, [errors])

  const renderWeightHelperText = () => {
    if (errors.weight?.type === 'required')
      return t('errors.weight-is-required')
    return null
  }

  // v This area is defining fields
  const renderFromAddressField = () => (
    <AddressAutoComplete
      control={control}
      label={t('from-address')}
      name="origin"
      controllerProps={{
        rules: {
          required,
        },
      }}
      textFieldProps={{
        error: errors.origin,
        helperText:
          errors.origin?.type === 'required' && t('errors.origin-is-required'),
      }}
      key="originField"
    />
  )
  const renderToAddressField = () => (
    <AddressAutoComplete
      control={control}
      label={t('to-address')}
      name="destination"
      controllerProps={{
        rules: {
          required,
        },
      }}
      textFieldProps={{
        error: errors.origin,
        helperText:
          errors.origin?.type === 'required' &&
          t('errors.destination-is-required'),
      }}
      key="destinationField"
    />
  )
  const renderParcelWeightField = () => (
    <Controller
      as={
        <NumberFormat
          customInput={TextField}
          thousandSeparator
          isNumericString
          allowNegative={false}
          // below is props of TextField
          label={t('parcel-weight')}
          type="text"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={t('estimate-weight')}>
                  <IconButton onClick={() => setCalModalOpen(true)}>
                    <img
                      src="/static/img/calculator_icon.svg"
                      height={25}
                      width={25}
                      alt={t('estimate-weight')}
                    />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
          variant="outlined"
          fullWidth
          error={errors.weight}
          helperText={renderWeightHelperText()}
          placeholder={t('in-grams')}
        />
      }
      name="weight"
      defaultValue=""
      rules={{
        required,
      }}
      control={control}
      key="parcelWeightField"
    />
  )
  const renderParcelSizeField = () => (
    <FormControl variant="outlined" fullWidth key="parcelSizeField">
      <InputLabel error={errors.boxSize}>{t('parcel-size')}</InputLabel>
      <Controller
        as={
          <Select
            variant="outlined"
            label={t('parcel-size')}
            fullWidth
            native
            error={errors.boxSize}
            inputProps={{ 'aria-label': t('parcel-size') }}
          >
            <option value="" hidden />
            {boxSizesKeysAndLabelsWithUndefined.map(([name, label]) => (
              <option value={name} key={name}>
                {t(label)}
              </option>
            ))}
          </Select>
        }
        control={control}
        name="boxSize"
        defaultValue=""
        rules={{
          required,
        }}
      />
      {errors.boxSize && (
        <FormHelperText error>
          {errors.boxSize?.type === 'required' &&
            t('errors.box-size-is-required')}
        </FormHelperText>
      )}
    </FormControl>
  )

  const renderFullForm = () => (
    <div className={classes.root}>
      <h3 className={classes.title}>{t('find-a-courier')}</h3>
      <Grid container className={classes.gridRoot}>
        <Grid item xs={12} sm={6}>
          {renderFromAddressField()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {renderToAddressField()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {renderParcelWeightField()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {renderParcelSizeField()}
        </Grid>
        {/* <Grid item xs={12} className={classes.noPaddingNoMargin}>
              <ButtonSp
                variant="text"
                onClick={() => setAdvancedOpen(!isAdvancedOpen)}
              >
                {!isAdvancedOpen ? t('advanced'):t('advanced-close')}
              </ButtonSp>
            </Grid> */}
        {/* <Collapse
              in={isAdvancedOpen}
              className={classes.noPaddingNoMargin}
              style={{ width: '100%' }}
            >
              <Grid container className={classes.gridRoot}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    as={
                      <DatePicker
                        inputVariant="outlined"
                        label={t('delivery-date')}
                        fullWidth
                        format="LL"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <EventIcon color="disabled" />
                            </InputAdornment>
                          ),
                        }}
                      />
                    }
                    control={control}
                    defaultValue={dayjs()}
                    name="sendDate"
                  />
                </Grid>
              </Grid>
            </Collapse> */}

        <Grid container item xs={12} direction="column" alignItems="center">
          <ButtonSp className={classes.submitBtn} type="submit">
            {t('search')}
          </ButtonSp>
          {/* <div style={{ height: 15 }} />
              <Link
                href=""
                onClick={(e) => {
                  e.preventDefault()
                  setMulDestModalOpen(true)
                }}
              >
                {t('multiple-parcel')}
              </Link> */}
        </Grid>
      </Grid>
    </div>
  )

  // v for the future version
  // const renderBarForm = () => (
  //   <Grid container>
  //     <Grid item xs={3}>{renderFromAddressField()}</Grid>
  //     <Grid item xs={3}>{renderToAddressField()}</Grid>
  //     <Grid item xs={2}>{renderParcelWeightField()}</Grid>
  //     <Grid item xs={2}>{renderParcelSizeField()}</Grid>
  //     <Grid item xs={2}>
  //       <ButtonSp className={classes.submitBtn} type="submit">
  //         {t('search')}
  //       </ButtonSp>
  //     </Grid>
  //   </Grid>
  // )

  return (
    <div>
      <form onSubmit={handleFormSubmit}>{renderFullForm()}</form>
      <CalWeightModal
        open={isCalModalOpen}
        onClose={() => setCalModalOpen(false)}
        setWeight={(weight) => {
          setValue('weight', weight)
          trigger('weight')
        }}
      />
      {/* <MultipleDestModal
        open={isMulDestModalOpen}
        onClose={() => setMulDestModalOpen(false)}
        submitFunction={handleMultiDestSubmit}
      /> */}
    </div>
  )
}

export default DomesticForm
